import {useEffect, useState} from "react";
import {Table} from "antd";
import {getInventoryByProduct} from "../../api/Api";
import {UnitType} from "../../api/Constants";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {Link} from "react-router";

export const ProductInventoryTable = ({productId, onApiFail, refresh, onRefresh, props}) => {
    const [inventory, setInventory] = useState([]);

    useEffect(() => {
        getInventoryByProduct(productId).then((x) => {
            const tableData = x.map((val, index) => {
                return {...val, key: val.id}
            });

            setInventory(tableData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [productId, refresh, onApiFail]);


    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                return <Link to={`/inventory/${record.id}`}>{val}</Link>
            }
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
        {
            title: 'Quantity Available',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.unit === UnitType.Each) {
                    return displayQuantity
                } else {
                    return `${displayQuantity} ${UnitType.Label[record.unit]}`
                }
            }
        }
    ]

    return <Table dataSource={inventory} columns={columns} pagination={false} />

}